import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerformactionRoutingModule } from './performaction-routing.module';
import { PerformActionPage } from '../../components/performaction/performaction.page';
import { PerformActionAuthenticateComponent } from '../../components/performaction/performactionauthenticate/performactionauthenticate.component';
import { PerformActionAllDoneModal } from '../../components/performaction/modals/perform-action-all-done/perform-action-all-done.modal';
import { OpenAllDoneModalComponent } from '../../components/performaction/open-all-done-modal/open-all-done-modal.component';
import { PerformActionDocumentPdfComponent } from '../../components/performaction/performactiondocumentpdf/performactiondocumentpdf.component';
import { PerformActionDocumentPdfImageComponent } from '../../components/performaction/performactiondocumentpdfimage/performactiondocumentpdfimage.component';
import { PerformActionDocumentRenderingComponent } from '../../components/performaction/performactiondocumentrendering/performactiondocumentrendering.component';
import { ActionSideListComponent } from '../../components/performaction/action-side-list/action-side-list.component';
import { PerformedActionRejectedModal } from '../../components/performaction/modals/performed-action-rejected/performed-action-rejected.modal';
import { ViewerSubHeaderComponent } from '../../components/performaction/viewer-header/viewer-sub-header.component';
import { ActionSummaryModal } from '../../components/performaction/modals/action-summary/action-summary.modal';
import { ViewerHeaderComponent } from '../../components/performaction/viewer-header/viewer-header.component';
import { PerformedActionAwaitingFilingModal } from '../../components/performaction/modals/performed-action-awaiting-filing/performed-action-awaiting-filing.modal';
import { PerformedActionAwaitingOtherPeopleModal } from '../../components/performaction/modals/performed-action-awaiting-other-people/performed-action-awaiting-other-people.modal';
import { PerformActionCertificateProviderComponent } from '../../components/performaction/performactioncertificateprovider/performactioncertificateprovider.component';
import { UserIdentificationDetailsComponent } from '../../components/performaction/user-identification-details/user-identification-details.component';
import { PerformActionPendingModal } from '../../components/performaction/modals/perform-action-pending/perform-action-pending.modal';
import { PerformActionApproveModal } from '../../components/performaction/modals/perform-action-approve.modal/perform-action-approve.modal';
import { PerformActionLinkingModal } from '../../components/performaction/modals/perform-action-linking.modal/perform-action-linking.modal';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { OpenIdConfigService } from '../../services/openidconfig.service';
import { SharedModule } from '../shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { isObservable, Observable } from 'rxjs';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PerformactioncertificatesComponent } from '../../components/performaction/performactioncertificates/performactioncertificates.component';
import { CreditSummaryExplanationModal } from 'src/app/modals/credit-summary-explanation/credit-summary-explanation.modal';
import { ChangesignatureproviderModal } from 'src/app/components/performaction/changesignatureprovider/changesignatureprovider.modal';
import { IdealPaymentButtonComponent } from 'src/app/components/performaction/ideal-payment-button/ideal-payment-button.component';
import { PerformActionFileModal } from 'src/app/components/performaction/modals/perform-action-file.modal/perform-action-file.modal';
import { PerformActionAdoptModal } from 'src/app/components/performaction/modals/perform-action-adopt.modal/perform-action-adopt.modal';
import { DocumentDetailsSummaryComponent } from 'src/app/components/performaction/components/document-details-summary.component';
import { DocumentActorSummaryComponent } from 'src/app/components/performaction/components/document-actor-summary.component';
import { DocumentActionsForActorComponent } from 'src/app/components/performaction/components/document-actions-for-actor.component';
import { PerformActionSignModal } from 'src/app/components/performaction/modals/perform-action-sign.modal/perform-action-sign.modal';
import { PerformedActionRejectModal } from 'src/app/components/performaction/modals/perform-action-reject.modal/perform-action-reject.modal';
import { ViewerDataService } from 'src/app/components/performaction/viewer-data.service';
import { ViewerModalService } from 'src/app/components/performaction/viewer-modal.service';
import { DisplayRequestUnavailableModal } from 'src/app/components/performaction/modals/display-request-unavailable.modal/display-request-unavailable.modal';
import { ViewerService } from 'src/app/components/performaction/viewer.service';
import { DisplayRequestcompletedModal } from 'src/app/components/performaction/modals/display-request-completed/display-request-completed.modal';
import { PerformedActionWithdrawnModal } from 'src/app/components/performaction/modals/performed-action-withdrawn/performed-action-withdrawn.modal';

const authFactory = (openIdConfigService: OpenIdConfigService) => {
  const config = openIdConfigService.getConfig();
  if (isObservable(config)) {
    return new StsConfigHttpLoader(<Observable<OpenIdConfiguration>>config);
  } else {
    return new StsConfigStaticLoader(<OpenIdConfiguration>config);
  }
};

@NgModule({
  declarations: [
    // Pages
    PerformActionPage,

    // Modals
    ActionSummaryModal,
    CreditSummaryExplanationModal,
    PerformedActionRejectedModal,
    PerformedActionWithdrawnModal,
    PerformedActionAwaitingOtherPeopleModal,
    PerformedActionAwaitingFilingModal,
    ChangesignatureproviderModal,
    PerformActionAdoptModal,
    PerformActionFileModal,
    PerformActionApproveModal,
    PerformActionLinkingModal,
    PerformActionSignModal,
    PerformedActionRejectModal,
    DisplayRequestUnavailableModal,
    DisplayRequestcompletedModal,
    // Components
    DocumentDetailsSummaryComponent,
    DocumentActorSummaryComponent,
    DocumentActionsForActorComponent,

    ViewerSubHeaderComponent,
    ViewerHeaderComponent,
    ActionSideListComponent,
    PerformActionAllDoneModal,
    PerformActionDocumentPdfComponent,
    PerformActionDocumentPdfImageComponent,
    PerformActionDocumentRenderingComponent,
    OpenAllDoneModalComponent,
    PerformActionAuthenticateComponent,
    PerformActionCertificateProviderComponent,
    PerformActionPendingModal,
    UserIdentificationDetailsComponent,
    PerformactioncertificatesComponent,
    IdealPaymentButtonComponent
  ],
  providers: [ViewerDataService, ViewerModalService, ViewerService],
  imports: [
    CommonModule,
    PerformactionRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OpenIdConfigService],
      }
    }),
    AngularSignaturePadModule,
  ]
})
export class PerformactionModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
